export const parseBulkUserList = (text) => {
  const lines = text.split('\n').map((line) => line.trim()).filter((line) => line.length > 0);
  const parsed = [];
  const errors = [];

  lines.forEach((line, index) => {
    const match = line.match(/^(.+),\s*([^\s,]+@[^\s,]+\.[^\s,]+)\s*$/i);
    if (!match) {
      errors.push({ line: index + 1, text: line });
      return;
    }
    parsed.push({ name: match[1].trim(), email: match[2].trim().toLowerCase() });
  });

  return { parsed, errors };
};

export const partitionBulkUsers = (parsed, existingUserEmails) => {
  const existingEmails = new Set(
    existingUserEmails.map((email) => email?.trim().toLowerCase()).filter(Boolean)
  );
  const usersToAdd = [];
  const alreadyPresent = [];

  parsed.forEach((user) => {
    if (existingEmails.has(user.email)) {
      alreadyPresent.push(user.email);
    } else {
      usersToAdd.push(user);
    }
  });

  return { usersToAdd, alreadyPresent };
};
